import { PROSECUTION, PUBLIC_DEFENSE, PARTICULAR_DEFENSE, JUDGE, INTERVEENING, VICTIM, ACCUSED, OPERATOR } from "../data/destinationTypes";
import { WaitingMessage } from "../components/extras/toastMessages";
import Swal from "sweetalert2";

class DestinationService {
    //Verifica si tiene defensa oficial
    getDestinations(type, audience){
        //Inicializo los datos
        let data = [];
        //Cargo la espera
        WaitingMessage('Buscando destinatarios');
        //Evalúo el tipo
        switch(parseInt(type)){
            case PROSECUTION:
                //Me fijo si hay datos
                if(audience.fiscal){
                    //Tengo que devolver el fiscal
                    data = [{
                        id: audience.fiscal.id,
                        descripcion: `${audience.fiscal.apellido}, ${audience.fiscal.nombre}`,
                        email: audience.fiscal.email
                    }];
                }
                //Me fijo si hay fiscalia
                if(audience.fiscalia){
                    //Tengo que agregar los datos
                    data = [
                        ...data,
                        {
                            id: audience.fiscalia.id,
                            descripcion: audience.fiscalia.descripcion,
                            email: audience.fiscalia.email
                        }
                    ]
                }
                break;
            case PUBLIC_DEFENSE:
                //Tengo que recorrer los imputados
                audience.imputadoList.map(accused => {
                    //Me fijo si hay menores
                    if(accused.menores){
                        //Me fijo que no esté agregado
                        if(!data.find(element => element.id === accused.menores.id)){
                            data = [
                                ...data,
                                {
                                    id: accused.menores.id,
                                    descripcion: accused.menores.descripcion,
                                    email: accused.menores.email
                                }
                            ]
                        }
                    }
                    //Me fijo si hay oficial
                    if(accused.defensoria){
                        //Me fijo que no esté agregado
                        if(!data.find(element => element.id === accused.defensoria.id)){
                            data = [
                                ...data,
                                {
                                    id: accused.defensoria.id,
                                    descripcion: accused.defensoria.descripcion,
                                    email: accused.defensoria.email
                                }
                            ]
                        }
                    }
                });
                //Tengo que recorrer las víctimas
                audience.victimaList.map(victim => {
                    //Me fijo si hay oficial
                    if(victim.defensoria){
                        //Me fijo que no esté agregado
                        if(!data.find(element => element.id === victim.defensoria.id)){
                            data = [
                                ...data,
                                {
                                    id: victim.defensoria.id,
                                    descripcion: victim.defensoria.descripcion,
                                    email: victim.defensoria.email
                                }
                            ]
                        }
                    }
                });
                break;
            case PARTICULAR_DEFENSE:
                //Tengo que recorrer los imputados
                audience.imputadoList.map(accused => {
                    //Me fijo si hay particulares
                    if(accused.imputadoParticularesList){
                        //Recorro los particulares
                        accused.imputadoParticularesList.map(particular => {
                            //Me fijo que no esté agregado
                            if(!data.find(element => element.id === particular.persona.id)){
                                //Lo agrego
                                data = [
                                    ...data,
                                    {
                                        id: particular.persona.id,
                                        descripcion: `${particular.persona.apellido}, ${particular.persona.nombre}`,
                                        email: particular.email
                                    }
                                ]
                            }
                        })
                    }
                });
                //Tengo que recorrer las víctimas
                audience.victimaList.map(victim => {
                    //Me fijo si hay particulares
                    if(victim.victimaParticularesList){
                        //Recorro los particulares
                        victim.victimaParticularesList.map(particular => {
                            //Me fijo que no esté agregado
                            if(!data.find(element => element.id === particular.persona.id)){
                                //Lo agrego
                                data = [
                                    ...data,
                                    {
                                        id: particular.persona.id,
                                        descripcion: `${particular.persona.apellido}, ${particular.persona.nombre}`,
                                        email: particular.email
                                    }
                                ]
                            }
                        })
                    }
                });
                break;
            case JUDGE:
                //Me fijo si hay jueces
                if(audience.audienciaJuezList){
                    //Recorro los jueces (solo los que no estén anulados)
                    audience.audienciaJuezList.filter(judge => judge.anulado === 0).map(judge => {
                        //Me fijo que no esté agregado
                        if(!data.find(element => element.id === judge.juez.id)){
                            //Lo agrego
                            data = [
                                ...data,
                                {
                                    id: judge.juez.id,
                                    descripcion: `${judge.juez.apellido}, ${judge.juez.nombre}`,
                                    email: judge.juez.email
                                }
                            ]
                        }
                    })
                }
                break;
            case OPERATOR:
                //Me fijo si hay operador
                if(audience.operador){
                    data = [{
                        id: audience.operador.id,
                        descripcion: `${audience.operador.apellido}, ${audience.operador.nombre}`,
                        email: audience.operador.email
                    }]
                }
                break;
            case ACCUSED:
                audience.imputadoList.map(accused => {
                    data = [
                        ...data,
                        {
                            id: accused.id,
                            descripcion: `${accused.persona.apellido}, ${accused.persona.nombre}`,
                            email: accused.email
                        }
                    ]
                })
                break;
            case VICTIM:
                audience.victimaList.map(victim => {
                    data = [
                        ...data,
                        {
                            id: victim.id,
                            descripcion: `${victim.persona.apellido}, ${victim.persona.nombre}`,
                            email: victim.email
                        }
                    ]
                })
                break;
            case INTERVEENING:
                audience.intervinientesList.map(interveening => {
                    data = [
                        ...data,
                        {
                            id: interveening.id,
                            descripcion: `${interveening.persona.apellido}, ${interveening.persona.nombre}`,
                            email: interveening.email
                        }
                    ]
                })
                break;
        }
        
        setTimeout(() => {
            Swal.close();
        }, 1000);
        //Retorno
        return data;
    }
}

export default new DestinationService();